// components/common/SuspenseFallback.tsx
import React from "react";
import { IonLoading } from "@ionic/react";

const SuspenseFallback: React.FC = () => (
  <div className="suspense-loader">
    <IonLoading
      isOpen={true}
      spinner="dots"
      duration={0}
      cssClass="custom-loading"
      backdropDismiss={false}
      animated={true}
      showBackdrop={true}
    />
  </div>
);

export default SuspenseFallback;
